import { assign } from 'lodash';

import { ClientActionType } from '../../actions/client.actions';
import { Actions } from '../../actions/index';
import { ReportActionType } from '../../actions/report-actions';
import { ReportResource } from '@mode/legacy/data-access-model-js';
import { AppState } from '@mode/legacy/types-app-state';
import { PersistentReportState } from '@mode/legacy/types-app-state';
import { ImmutableRecordSet } from '@mode/legacy/types-app-state';

export const initialPersistentReportState: PersistentReportState = new ImmutableRecordSet<ReportResource>('token');

function reportReducer(state = initialPersistentReportState, action: Actions): PersistentReportState {
  switch (action.type) {
    case ClientActionType.LoadReportSuccess:
      return state.mergeRecords([action.reportResource]);
    case ReportActionType.UpdateReportSuccess:
      return state.mergeRecords([action.payload.report]);
    case ReportActionType.UpdateSelectedReportSpaceSuccess:
      return state.mergeRecords([assign(state.getRecords()[0], { space_token: action.payload.space.token })]);
  }

  return state;
}

export const PersistentReportReducer = reportReducer;
